var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("bimini-default-section", {
    staticClass: "menu--section-bimini_aperitifs menu--section-wine_list",
    attrs: {
      menu: _vm.menu,
      section: _vm.section,
      "menu-item-component": "wine-list-item",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }